import { Component, OnInit } from '@angular/core';

import { PhotoThumbnailSizes } from '@site-mate/dashpivot-shared-library';

import { AppType } from 'app/apps/app-control-type.model';
import { TemplateFieldBaseComponent } from 'app/form-fields/common/template/template-field-base.component';

import { PhotoThumbnailDropdownOptions } from './photo-thumbnail-dropdown/photo-thumbnail-dropdown-options.model';

@Component({
  selector: 'cc-app-photo',
  templateUrl: 'photo-template.component.html',
  styleUrls: ['../../common/template/form-control.component.scss'],
})
export class PhotoTemplateComponent extends TemplateFieldBaseComponent implements OnInit {
  appType = AppType;
  readonly thumbnailSizes = PhotoThumbnailSizes;
  readonly photoThumbnailOptions = PhotoThumbnailDropdownOptions;
  thumbnailSrc = '';

  ngOnInit() {
    super.ngOnInit();
    this.setPhotoThumbnailChange();
  }

  setPhotoThumbnailChange() {
    this.thumbnailSrc = this.getThumbnailSrc();
  }

  getThumbnailSrc() {
    const thumbnailSize = this.model.photoThumbnailSize || PhotoThumbnailSizes.Small;
    return `assets/images/template-editor/photo-thumbnail-sizes/thumbnail-${thumbnailSize}.svg`;
  }
}
